import { dashboard } from './DashBoard';
import { master } from './master';

import { Admin } from './admin';
import { other } from './other';
import { jd } from './accounts';
import { reports } from './reports';

//-----------------------|| MENU ITEMS ||-----------------------//

const menuItems = {
    items: [dashboard, Admin, jd, master, reports, other]
};

export default menuItems;
